import Vue from 'vue'
import App from './App'
import {router} from './router'
import VueResource from 'vue-resource';
require('./libs/core.js');
require('./libs/jsBridge.js');
var FastClick =require('./libs/fastclick.js');

FastClick.attach(document.body);

Vue.use(VueResource);
// Vue.use(vueTouch);

import {} from './filters/dateFormat';
import {} from './filters/user';
import {} from './filters/time';
import {} from './filters/parseCity';

router.start(App, 'app');


Vue.directive('go', {
  update: function (value) {
    //console.log(this.params.scrollHeight); // -> "hi"

  }
});

Vue.directive('dom', {
  update: function (value) {
    if (this.vm.doms == null)
      this.vm.doms = {};
    this.vm.doms[value] = this.el;
  }
});



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/